function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.64 12.02 9.79.64A1.3 1.3 0 0 0 8.67 0c-.46 0-.88.24-1.12.63L.71 12.02A1.31 1.31 0 0 0 1.83 14H15.5a1.31 1.31 0 0 0 1.13-1.98zm-7.2-.35H7.9V10.1h1.56v1.56zm0-3.11H7.9v-3.9h1.56v3.9z"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 14",
    width: 17,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNyAxNCIgd2lkdGg9IjE3IiBoZWlnaHQ9IjE0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xNi42NCAxMi4wMiA5Ljc5LjY0QTEuMyAxLjMgMCAwIDAgOC42NyAwYy0uNDYgMC0uODguMjQtMS4xMi42M0wuNzEgMTIuMDJBMS4zMSAxLjMxIDAgMCAwIDEuODMgMTRIMTUuNWExLjMxIDEuMzEgMCAwIDAgMS4xMy0xLjk4em0tNy4yLS4zNUg3LjlWMTAuMWgxLjU2djEuNTZ6bTAtMy4xMUg3Ljl2LTMuOWgxLjU2djMuOXoiLz48L3N2Zz4K";
export { ForwardRef as ReactComponent };